import { render, staticRenderFns } from "./ChartXLTJ_Gas.vue?vue&type=template&id=96c863ba&scoped=true&"
import script from "./ChartXLTJ_Gas.vue?vue&type=script&lang=js&"
export * from "./ChartXLTJ_Gas.vue?vue&type=script&lang=js&"
import style0 from "./ChartXLTJ_Gas.vue?vue&type=style&index=0&id=96c863ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c863ba",
  null
  
)

export default component.exports